import { render, staticRenderFns } from "./GrowerLoanTab.vue?vue&type=template&id=4609dbde&scoped=true&"
import script from "./GrowerLoanTab.vue?vue&type=script&lang=js&"
export * from "./GrowerLoanTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerLoanTab.vue?vue&type=style&index=0&id=4609dbde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4609dbde",
  null
  
)

export default component.exports